// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "nomadize-f4fbf.firebaseapp.com",
  "projectId": "nomadize-f4fbf",
  "storageBucket": "nomadize-f4fbf.appspot.com",
  "messagingSenderId": "920294830528",
  "appId": "1:920294830528:web:5f57ff46c82fce33f25825",
  "measurementId": "G-RRT3RH5F1T",
  "apiKey": "AIzaSyAMTveqAorhHGShMdiBl9JmEbXLpiV0WTY"
};
